import { About } from "../Pages/About";
import { Home } from "../Pages/Home";
import { HomeProfi } from "../Event/Home/HomeProfi";
import { Login, LoginModal } from "../Pages/Login";
import { Logout, LogoutModal } from "../Pages/Logout";
import { ApiTestNewGuid } from "../Api/Entity";
import { AccountEdit } from "../Pages/AccountEdit";
import { RegisterUser, RegisterUserModal } from "../Pages/RegisterUser";
import { AlleUsers } from "../Pages/AlleUsers";
import { getRoleName, getRoleNames } from "./Constants";
import { DashboardOutlined, HomeOutlined } from "@ant-design/icons/lib/icons";
import { Anfrage, AnfrageModal } from "../Pages/Anfrage";
import { Confirmemail } from "./Confirmemail";
import { ROLE_NAME } from "./Constants";
import { ForgotPassword } from "../Pages/ForgotPassword";
import { LayoutData } from "../Structur/Aconlayout";
import { JahrFeiertage } from "../Event/JahrFeiertage";
import { PdfViewer } from "../Helper/PdfViewer";
import { PdfTestHome } from "../Pdf/PdfTestHome";
import { PdfViewHome } from "../Pdf/PdfViewHome";
import { PasswortChange } from "../Pages/PasswortChange";
import { Kontenrahmen } from "../Profi/Kontenrahmen";
import { Aconkunden } from "../Profi/Aconkunden";
import { EvidenzDaten } from "../Profi/EvidenzDaten";

export const mainNav = () => {
  const { user } = LayoutData();
  const aktMainNav = [
    {
      path: "/",
      name: "Home",
      element: <HomeProfi />,
      isMenu: true,
      isPrivate: false,
      //notLogin: true,
      icon: <HomeOutlined />,
    },
    {
      path: "/home",
      name: "Home",
      element: <HomeProfi />,
      isMenu: false,
      isPrivate: false,
    },
    {
      path: "/homeevent",
      name: "HomeEvent",
      element: <HomeProfi />,
      isMenu: false,
      isPrivate: false,
    },
    {
      path: "#",
      name: "Profi",
      isMenu: true,
      isDropdown: true,
      isPrivate: true,
      nav: [
        {
          path: "/kontenrahmen",
          name: "Konten der Buchhaltung",
          element: <Kontenrahmen />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ADMIN]),
        },
        {
          path: "/evidenzDaten1",
          name: "EvidenzDaten Acon",
          element: <EvidenzDaten gruppe={1} />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ADMIN]),
        },
        {
          path: "/evidenzDaten3",
          name: "EvidenzDaten Printex",
          element: <EvidenzDaten gruppe={3} />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ADMIN]),
        },
        {
          path: "/aconkunden",
          name: "Aconkunden",
          element: <Aconkunden />,
          isMenu: true,
          isPrivate: true,
        },
      ],
    },
    {
      path: "#",
      name: "Verwaltung",
      isMenu: true,
      isDropdown: true,
      isPrivate: true,
      nav: [
        {
          path: "/accountEdit",
          name: "Benutzerdaten bearbeiten",
          element: <AccountEdit />,
          isMenu: true,
          isPrivate: true,
        },
        {
          path: "/alleUsers",
          name: "Alle Benutzer",
          element: <AlleUsers />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ADMIN]),
        },
        {
          path: "/about",
          name: "About",
          element: <About />,
          isMenu: true,
          isPrivate: user.statusOK,
        },
        {
          path: "/jahrfeiertage",
          name: "Österreichische Feiertage",
          element: <JahrFeiertage />,
          isMenu: true,
          isPrivate: false,
        },
        {
          path: "/anfrage",
          name: "Anfrage",
          element: <Anfrage />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "/anfragemodal",
          name: "Anfrage Modal",
          element: <AnfrageModal />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "#",
          name: "Details",
          isMenu: true,
          isDropdown: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
          nav: [
            {
              path: "/login",
              name: "Login",
              element: <Login />,
              isMenu: true,
              isPrivate: true,
              roles: getRoleNames([ROLE_NAME.ADMIN]),
            },
          ],
        },
      ],
    },
    {
      path: "#",
      name: "Hilfsprogramme",
      isMenu: true,
      isPrivate: true,
      isDropdown: true,
      roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
      nav: [
        {
          path: "/registerUser",
          name: "Neuanlage",
          element: <RegisterUser />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "/registerUserModal",
          name: "Neuanmeldung Modal",
          element: <RegisterUserModal />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "/login",
          name: "Login",
          element: <Login />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "/loginModal",
          name: "Login Modal",
          element: <LoginModal />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
        {
          path: "/logoutModal",
          name: "Logout Modal",
          element: <LogoutModal />,
          isMenu: true,
          isPrivate: true,
          roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
        },
      ],
    },
    {
      path: "/logout",
      name: "Logout",
      element: <LogoutModal />,
      isMenu: true,
      isPrivate: user.statusOK || !user.isAuthenticated,
    },
    {
      path: "/login",
      name: "Login",
      element: <LoginModal />,
      isMenu: true,
      isPrivate: false,
      notLogin: true,
    },
    {
      path: "/registerUserModal",
      name: "Neuanmeldung",
      element: <RegisterUserModal />,
      isMenu: true,
      isPrivate: false,
      notLogin: true,
    },
    {
      path: "/about",
      name: "About",
      element: <About />,
      isMenu: true,
      isPrivate: false,
      notLogin: true,
    },
    {
      path: "/apitest",
      name: "API-Test",
      element: <ApiTestNewGuid />,
      isMenu: true,
      isPrivate: false,
      notLogin: true,
    },    
    {
      path: "/forgot-password",
      //name: "Confirmed EMail",
      element: <ForgotPassword />,
      //isMenu: false,
      //isPrivate: false,
      //notLogin: false,
      //roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
    },
    {
      path: "/passwordchange",
      element: <PasswortChange />,
    },
    {
      path: "/confirmemail",
      name: "Confirmed EMail",
      element: <Confirmemail />,
      isMenu: true,
      isPrivate: false,
      notLogin: true,
      roles: getRoleNames([ROLE_NAME.ENTWICKLER]),
    },
    {
      path: "/pdfViewer",
      name: "pdfViewer",
      element: <PdfViewer />,
    },
    {
      path: "/PdfTesthome",
      element: <PdfTestHome />,
    },
    {
      path: "/pdfViewHome",
      element: <PdfViewHome />,
    },
    {
      path: "/apitest",
      name: "API-Test",
      element: <ApiTestNewGuid />,
      isMenu: true,
      isPrivate: true,
      roles: getRoleNames([ROLE_NAME.ADMIN]),
    },
  ];
  return aktMainNav;
};
